import { render, staticRenderFns } from "./BookMatchRoomType.vue?vue&type=template&id=5f720d76&scoped=true&"
import script from "./BookMatchRoomType.vue?vue&type=script&lang=js&"
export * from "./BookMatchRoomType.vue?vue&type=script&lang=js&"
import style0 from "./BookMatchRoomType.vue?vue&type=style&index=0&id=5f720d76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f720d76",
  null
  
)

export default component.exports